/**
 * Tanjong Life · L9b · "How did you get better?" — the direct door.
 *
 * The beat lives in `tanjong-selfevolve-steps.ts` because the self-account scenario
 * offers the same proof at the end of its own answer; this scenario is the shortcut for
 * a room that asks for it straight out. Scoped to `siu-triage-sentinel`.
 */
import type { Scenario } from '../director.js';
import { SELF_EVOLVE_STEPS } from './tanjong-selfevolve-steps.js';

export const tanjongSelfEvolve: Scenario = {
  id: 'tanjong-self-evolve',
  orgId: 'tanjong-life',
  agentPk: 'siu-triage-sentinel',
  keywords: ['how did you get better', 'prove it learned', 'show me you learned'],
  steps: SELF_EVOLVE_STEPS,
};
